import { IsDateString, IsIn, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class CreateBlastChillingRecordDto {
  @IsUUID()
  lotId!: string;

  @IsIn(['POSITIVE', 'NEGATIVE'])
  chillingType!: 'POSITIVE' | 'NEGATIVE';

  @IsNumber()
  initialTemperature!: number;

  @IsNumber()
  finalTemperature!: number;

  @IsDateString()
  startedAt!: string;

  @IsDateString()
  endedAt!: string;

  // Signature reference: an http(s) presigned URL (in-app flow) OR a durable
  // storage key (server-side GPT flow). Provenance (`ingestedVia`) and the
  // "sign later" flag are NOT accepted from clients — both are server-controlled
  // to prevent provenance spoofing and unsigned-record forgery on this PUBLIC
  // endpoint. See gpt-self-check.service for the server-set values.
  @IsOptional()
  @IsString()
  signatureImage?: string;

  @IsOptional()
  @IsString()
  @OptionalStringTransform()
  correctiveAction?: string;

  @IsOptional()
  @IsString()
  @OptionalStringTransform()
  notes?: string;
}
